import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  query: { value: "", matchMode: "contains" },
  type: { value: "", matchMode: "contains" },
  description: { value: "", matchMode: "contains" },
};

export const useFilterDashboardStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
